/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as TermsRouteImport } from "./routes/terms";
import { Route as SignupRouteImport } from "./routes/signup";
import { Route as PrivacyRouteImport } from "./routes/privacy";
import { Route as LoginRouteImport } from "./routes/login";
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as SignupIndexRouteImport } from "./routes/signup/index";
import { Route as LoginIndexRouteImport } from "./routes/login/index";
import { Route as SignupCheckEmailRouteImport } from "./routes/signup/check-email";
import { Route as LoginCheckEmailRouteImport } from "./routes/login/check-email";
import { Route as InviteCodeRouteImport } from "./routes/invite/$code";
import { Route as AuthenticatedWorkspacesRouteImport } from "./routes/_authenticated/workspaces";
import { Route as AuthenticatedSupportRouteImport } from "./routes/_authenticated/support";
import { Route as AuthenticatedSuperuserRouteImport } from "./routes/_authenticated/superuser";
import { Route as AuthenticatedAccountRouteImport } from "./routes/_authenticated/account";
import { Route as AuthenticatedWorkspacesIndexRouteImport } from "./routes/_authenticated/workspaces/index";
import { Route as AuthenticatedAccountIndexRouteImport } from "./routes/_authenticated/account/index";
import { Route as AuthenticatedWorkspacesCreateRouteImport } from "./routes/_authenticated/workspaces/create";
import { Route as AuthenticatedWorkspacesSlugRouteImport } from "./routes/_authenticated/workspaces/$slug";
import { Route as AuthenticatedSuperuserWorkspacesRouteImport } from "./routes/_authenticated/superuser/workspaces";
import { Route as AuthenticatedSuperuserModelsRouteImport } from "./routes/_authenticated/superuser/models";
import { Route as AuthenticatedSuperuserInvitesRouteImport } from "./routes/_authenticated/superuser/invites";
import { Route as AuthenticatedSuperuserIntegrationsRouteImport } from "./routes/_authenticated/superuser/integrations";
import { Route as AuthenticatedSuperuserAiSettingsRouteImport } from "./routes/_authenticated/superuser/ai-settings";
import { Route as AuthenticatedDocsDocIdRouteImport } from "./routes/_authenticated/docs/$docId";
import { Route as AuthenticatedConnectServiceRouteImport } from "./routes/_authenticated/connect/$service";
import { Route as AuthenticatedAccountIntegrationsRouteImport } from "./routes/_authenticated/account/integrations";
import { Route as AuthenticatedAccountApiKeysRouteImport } from "./routes/_authenticated/account/api-keys";
import { Route as AuthenticatedWorkspacesSlugIndexRouteImport } from "./routes/_authenticated/workspaces/$slug/index";
import { Route as AuthenticatedSuperuserSkillsIndexRouteImport } from "./routes/_authenticated/superuser/skills/index";
import { Route as AuthenticatedWorkspacesSlugSubscriptionRouteImport } from "./routes/_authenticated/workspaces/$slug/subscription";
import { Route as AuthenticatedWorkspacesSlugSettingsRouteImport } from "./routes/_authenticated/workspaces/$slug/settings";
import { Route as AuthenticatedWorkspacesSlugProjectsRouteImport } from "./routes/_authenticated/workspaces/$slug/projects";
import { Route as AuthenticatedWorkspacesSlugMembersRouteImport } from "./routes/_authenticated/workspaces/$slug/members";
import { Route as AuthenticatedWorkspacesSlugIntegrationsRouteImport } from "./routes/_authenticated/workspaces/$slug/integrations";
import { Route as AuthenticatedWorkspacesSlugAiUsageRouteImport } from "./routes/_authenticated/workspaces/$slug/ai-usage";
import { Route as AuthenticatedWorkspacesSlugAgentKeysRouteImport } from "./routes/_authenticated/workspaces/$slug/agent-keys";
import { Route as AuthenticatedSuperuserSkillsNewRouteImport } from "./routes/_authenticated/superuser/skills/new";
import { Route as AuthenticatedSuperuserSkillsImportRouteImport } from "./routes/_authenticated/superuser/skills/import";
import { Route as AuthenticatedSuperuserSkillsSkillIdRouteImport } from "./routes/_authenticated/superuser/skills/$skillId";
import { Route as AuthenticatedAccountIntegrationsCallbackRouteImport } from "./routes/_authenticated/account/integrations/callback";
import { Route as AuthenticatedWorkspacesSlugProjectsIndexRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/index";
import { Route as AuthenticatedWorkspacesSlugProjectsCreateRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/create";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug";
import { Route as AuthenticatedWorkspacesSlugCreateProfileRouteImport } from "./routes/_authenticated/workspaces/$slug/create/profile";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugIndexRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/index";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugWelcomeRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/welcome";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugTasksRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/tasks";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugSettingsRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/settings";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugProjectContextRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/project-context";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugMembersRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/members";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugIntegrationsRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/integrations";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/create";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugCrRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/cr";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugChangeRequestsRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/change-requests";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugAgentKeysRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/agent-keys";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugToolsIndexRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/tools/index";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsIndexRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions/index";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsIndexRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/skills/index";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugMessagesIndexRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/messages/index";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugDocsIndexRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/docs/index";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugChatsIndexRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/chats/index";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamIndexRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/index";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsSuggestionIdRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions/$suggestionId";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsNewRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/skills/new";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsImportRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/skills/import";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsSkillIdRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/skills/$skillId";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugDocsDocIdRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/docs/$docId";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugCreateInviteRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/create/invite";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugCreateDocsRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/create/docs";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugCrCrIdRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/cr/$crId";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugChatsChatIdRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/chats/$chatId";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamNewRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/new";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamPersonaIdRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/$personaId";
import { Route as AuthenticatedWorkspacesSlugProjectsProjectSlugToolsSurfaceToolIdRouteImport } from "./routes/_authenticated/workspaces/$slug/projects/$projectSlug/tools/$surface/$toolId";

const TermsRoute = TermsRouteImport.update({
  id: "/terms",
  path: "/terms",
  getParentRoute: () => rootRouteImport,
} as any);
const SignupRoute = SignupRouteImport.update({
  id: "/signup",
  path: "/signup",
  getParentRoute: () => rootRouteImport,
} as any);
const PrivacyRoute = PrivacyRouteImport.update({
  id: "/privacy",
  path: "/privacy",
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const SignupIndexRoute = SignupIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => SignupRoute,
} as any);
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => LoginRoute,
} as any);
const SignupCheckEmailRoute = SignupCheckEmailRouteImport.update({
  id: "/check-email",
  path: "/check-email",
  getParentRoute: () => SignupRoute,
} as any);
const LoginCheckEmailRoute = LoginCheckEmailRouteImport.update({
  id: "/check-email",
  path: "/check-email",
  getParentRoute: () => LoginRoute,
} as any);
const InviteCodeRoute = InviteCodeRouteImport.update({
  id: "/invite/$code",
  path: "/invite/$code",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedWorkspacesRoute = AuthenticatedWorkspacesRouteImport.update({
  id: "/workspaces",
  path: "/workspaces",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedSupportRoute = AuthenticatedSupportRouteImport.update({
  id: "/support",
  path: "/support",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedSuperuserRoute = AuthenticatedSuperuserRouteImport.update({
  id: "/superuser",
  path: "/superuser",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedWorkspacesIndexRoute =
  AuthenticatedWorkspacesIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedWorkspacesRoute,
  } as any);
const AuthenticatedAccountIndexRoute =
  AuthenticatedAccountIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any);
const AuthenticatedWorkspacesCreateRoute =
  AuthenticatedWorkspacesCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => AuthenticatedWorkspacesRoute,
  } as any);
const AuthenticatedWorkspacesSlugRoute =
  AuthenticatedWorkspacesSlugRouteImport.update({
    id: "/$slug",
    path: "/$slug",
    getParentRoute: () => AuthenticatedWorkspacesRoute,
  } as any);
const AuthenticatedSuperuserWorkspacesRoute =
  AuthenticatedSuperuserWorkspacesRouteImport.update({
    id: "/workspaces",
    path: "/workspaces",
    getParentRoute: () => AuthenticatedSuperuserRoute,
  } as any);
const AuthenticatedSuperuserModelsRoute =
  AuthenticatedSuperuserModelsRouteImport.update({
    id: "/models",
    path: "/models",
    getParentRoute: () => AuthenticatedSuperuserRoute,
  } as any);
const AuthenticatedSuperuserInvitesRoute =
  AuthenticatedSuperuserInvitesRouteImport.update({
    id: "/invites",
    path: "/invites",
    getParentRoute: () => AuthenticatedSuperuserRoute,
  } as any);
const AuthenticatedSuperuserIntegrationsRoute =
  AuthenticatedSuperuserIntegrationsRouteImport.update({
    id: "/integrations",
    path: "/integrations",
    getParentRoute: () => AuthenticatedSuperuserRoute,
  } as any);
const AuthenticatedSuperuserAiSettingsRoute =
  AuthenticatedSuperuserAiSettingsRouteImport.update({
    id: "/ai-settings",
    path: "/ai-settings",
    getParentRoute: () => AuthenticatedSuperuserRoute,
  } as any);
const AuthenticatedDocsDocIdRoute = AuthenticatedDocsDocIdRouteImport.update({
  id: "/docs/$docId",
  path: "/docs/$docId",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedConnectServiceRoute =
  AuthenticatedConnectServiceRouteImport.update({
    id: "/connect/$service",
    path: "/connect/$service",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAccountIntegrationsRoute =
  AuthenticatedAccountIntegrationsRouteImport.update({
    id: "/integrations",
    path: "/integrations",
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any);
const AuthenticatedAccountApiKeysRoute =
  AuthenticatedAccountApiKeysRouteImport.update({
    id: "/api-keys",
    path: "/api-keys",
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any);
const AuthenticatedWorkspacesSlugIndexRoute =
  AuthenticatedWorkspacesSlugIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedWorkspacesSlugRoute,
  } as any);
const AuthenticatedSuperuserSkillsIndexRoute =
  AuthenticatedSuperuserSkillsIndexRouteImport.update({
    id: "/skills/",
    path: "/skills/",
    getParentRoute: () => AuthenticatedSuperuserRoute,
  } as any);
const AuthenticatedWorkspacesSlugSubscriptionRoute =
  AuthenticatedWorkspacesSlugSubscriptionRouteImport.update({
    id: "/subscription",
    path: "/subscription",
    getParentRoute: () => AuthenticatedWorkspacesSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugSettingsRoute =
  AuthenticatedWorkspacesSlugSettingsRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => AuthenticatedWorkspacesSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsRoute =
  AuthenticatedWorkspacesSlugProjectsRouteImport.update({
    id: "/projects",
    path: "/projects",
    getParentRoute: () => AuthenticatedWorkspacesSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugMembersRoute =
  AuthenticatedWorkspacesSlugMembersRouteImport.update({
    id: "/members",
    path: "/members",
    getParentRoute: () => AuthenticatedWorkspacesSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugIntegrationsRoute =
  AuthenticatedWorkspacesSlugIntegrationsRouteImport.update({
    id: "/integrations",
    path: "/integrations",
    getParentRoute: () => AuthenticatedWorkspacesSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugAiUsageRoute =
  AuthenticatedWorkspacesSlugAiUsageRouteImport.update({
    id: "/ai-usage",
    path: "/ai-usage",
    getParentRoute: () => AuthenticatedWorkspacesSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugAgentKeysRoute =
  AuthenticatedWorkspacesSlugAgentKeysRouteImport.update({
    id: "/agent-keys",
    path: "/agent-keys",
    getParentRoute: () => AuthenticatedWorkspacesSlugRoute,
  } as any);
const AuthenticatedSuperuserSkillsNewRoute =
  AuthenticatedSuperuserSkillsNewRouteImport.update({
    id: "/skills/new",
    path: "/skills/new",
    getParentRoute: () => AuthenticatedSuperuserRoute,
  } as any);
const AuthenticatedSuperuserSkillsImportRoute =
  AuthenticatedSuperuserSkillsImportRouteImport.update({
    id: "/skills/import",
    path: "/skills/import",
    getParentRoute: () => AuthenticatedSuperuserRoute,
  } as any);
const AuthenticatedSuperuserSkillsSkillIdRoute =
  AuthenticatedSuperuserSkillsSkillIdRouteImport.update({
    id: "/skills/$skillId",
    path: "/skills/$skillId",
    getParentRoute: () => AuthenticatedSuperuserRoute,
  } as any);
const AuthenticatedAccountIntegrationsCallbackRoute =
  AuthenticatedAccountIntegrationsCallbackRouteImport.update({
    id: "/callback",
    path: "/callback",
    getParentRoute: () => AuthenticatedAccountIntegrationsRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsIndexRoute =
  AuthenticatedWorkspacesSlugProjectsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsCreateRoute =
  AuthenticatedWorkspacesSlugProjectsCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugRouteImport.update({
    id: "/$projectSlug",
    path: "/$projectSlug",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsRoute,
  } as any);
const AuthenticatedWorkspacesSlugCreateProfileRoute =
  AuthenticatedWorkspacesSlugCreateProfileRouteImport.update({
    id: "/create/profile",
    path: "/create/profile",
    getParentRoute: () => AuthenticatedWorkspacesSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugIndexRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugWelcomeRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugWelcomeRouteImport.update({
    id: "/welcome",
    path: "/welcome",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugTasksRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugTasksRouteImport.update({
    id: "/tasks",
    path: "/tasks",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRouteImport.update({
    id: "/suggestions",
    path: "/suggestions",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugSettingsRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugSettingsRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugProjectContextRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugProjectContextRouteImport.update(
    {
      id: "/project-context",
      path: "/project-context",
      getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
    } as any,
  );
const AuthenticatedWorkspacesSlugProjectsProjectSlugMembersRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugMembersRouteImport.update({
    id: "/members",
    path: "/members",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugIntegrationsRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugIntegrationsRouteImport.update({
    id: "/integrations",
    path: "/integrations",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRouteImport.update({
    id: "/create",
    path: "/create",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugCrRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugCrRouteImport.update({
    id: "/cr",
    path: "/cr",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugChangeRequestsRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugChangeRequestsRouteImport.update(
    {
      id: "/change-requests",
      path: "/change-requests",
      getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
    } as any,
  );
const AuthenticatedWorkspacesSlugProjectsProjectSlugAgentKeysRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugAgentKeysRouteImport.update({
    id: "/agent-keys",
    path: "/agent-keys",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugToolsIndexRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugToolsIndexRouteImport.update({
    id: "/tools/",
    path: "/tools/",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsIndexRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsIndexRouteImport.update(
    {
      id: "/",
      path: "/",
      getParentRoute: () =>
        AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRoute,
    } as any,
  );
const AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsIndexRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsIndexRouteImport.update({
    id: "/skills/",
    path: "/skills/",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugMessagesIndexRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugMessagesIndexRouteImport.update(
    {
      id: "/messages/",
      path: "/messages/",
      getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
    } as any,
  );
const AuthenticatedWorkspacesSlugProjectsProjectSlugDocsIndexRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugDocsIndexRouteImport.update({
    id: "/docs/",
    path: "/docs/",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugChatsIndexRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugChatsIndexRouteImport.update({
    id: "/chats/",
    path: "/chats/",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamIndexRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamIndexRouteImport.update({
    id: "/ai-team/",
    path: "/ai-team/",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsSuggestionIdRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsSuggestionIdRouteImport.update(
    {
      id: "/$suggestionId",
      path: "/$suggestionId",
      getParentRoute: () =>
        AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRoute,
    } as any,
  );
const AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsNewRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsNewRouteImport.update({
    id: "/skills/new",
    path: "/skills/new",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsImportRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsImportRouteImport.update({
    id: "/skills/import",
    path: "/skills/import",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsSkillIdRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsSkillIdRouteImport.update(
    {
      id: "/skills/$skillId",
      path: "/skills/$skillId",
      getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
    } as any,
  );
const AuthenticatedWorkspacesSlugProjectsProjectSlugDocsDocIdRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugDocsDocIdRouteImport.update({
    id: "/docs/$docId",
    path: "/docs/$docId",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugCreateInviteRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugCreateInviteRouteImport.update({
    id: "/invite",
    path: "/invite",
    getParentRoute: () =>
      AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugCreateDocsRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugCreateDocsRouteImport.update({
    id: "/docs",
    path: "/docs",
    getParentRoute: () =>
      AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugCrCrIdRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugCrCrIdRouteImport.update({
    id: "/$crId",
    path: "/$crId",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugCrRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugChatsChatIdRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugChatsChatIdRouteImport.update({
    id: "/chats/$chatId",
    path: "/chats/$chatId",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamNewRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamNewRouteImport.update({
    id: "/ai-team/new",
    path: "/ai-team/new",
    getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
  } as any);
const AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamPersonaIdRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamPersonaIdRouteImport.update(
    {
      id: "/ai-team/$personaId",
      path: "/ai-team/$personaId",
      getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
    } as any,
  );
const AuthenticatedWorkspacesSlugProjectsProjectSlugToolsSurfaceToolIdRoute =
  AuthenticatedWorkspacesSlugProjectsProjectSlugToolsSurfaceToolIdRouteImport.update(
    {
      id: "/tools/$surface/$toolId",
      path: "/tools/$surface/$toolId",
      getParentRoute: () => AuthenticatedWorkspacesSlugProjectsProjectSlugRoute,
    } as any,
  );

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/login": typeof LoginRouteWithChildren;
  "/privacy": typeof PrivacyRoute;
  "/signup": typeof SignupRouteWithChildren;
  "/terms": typeof TermsRoute;
  "/account": typeof AuthenticatedAccountRouteWithChildren;
  "/superuser": typeof AuthenticatedSuperuserRouteWithChildren;
  "/support": typeof AuthenticatedSupportRoute;
  "/workspaces": typeof AuthenticatedWorkspacesRouteWithChildren;
  "/invite/$code": typeof InviteCodeRoute;
  "/login/check-email": typeof LoginCheckEmailRoute;
  "/signup/check-email": typeof SignupCheckEmailRoute;
  "/login/": typeof LoginIndexRoute;
  "/signup/": typeof SignupIndexRoute;
  "/account/api-keys": typeof AuthenticatedAccountApiKeysRoute;
  "/account/integrations": typeof AuthenticatedAccountIntegrationsRouteWithChildren;
  "/connect/$service": typeof AuthenticatedConnectServiceRoute;
  "/docs/$docId": typeof AuthenticatedDocsDocIdRoute;
  "/superuser/ai-settings": typeof AuthenticatedSuperuserAiSettingsRoute;
  "/superuser/integrations": typeof AuthenticatedSuperuserIntegrationsRoute;
  "/superuser/invites": typeof AuthenticatedSuperuserInvitesRoute;
  "/superuser/models": typeof AuthenticatedSuperuserModelsRoute;
  "/superuser/workspaces": typeof AuthenticatedSuperuserWorkspacesRoute;
  "/workspaces/$slug": typeof AuthenticatedWorkspacesSlugRouteWithChildren;
  "/workspaces/create": typeof AuthenticatedWorkspacesCreateRoute;
  "/account/": typeof AuthenticatedAccountIndexRoute;
  "/workspaces/": typeof AuthenticatedWorkspacesIndexRoute;
  "/account/integrations/callback": typeof AuthenticatedAccountIntegrationsCallbackRoute;
  "/superuser/skills/$skillId": typeof AuthenticatedSuperuserSkillsSkillIdRoute;
  "/superuser/skills/import": typeof AuthenticatedSuperuserSkillsImportRoute;
  "/superuser/skills/new": typeof AuthenticatedSuperuserSkillsNewRoute;
  "/workspaces/$slug/agent-keys": typeof AuthenticatedWorkspacesSlugAgentKeysRoute;
  "/workspaces/$slug/ai-usage": typeof AuthenticatedWorkspacesSlugAiUsageRoute;
  "/workspaces/$slug/integrations": typeof AuthenticatedWorkspacesSlugIntegrationsRoute;
  "/workspaces/$slug/members": typeof AuthenticatedWorkspacesSlugMembersRoute;
  "/workspaces/$slug/projects": typeof AuthenticatedWorkspacesSlugProjectsRouteWithChildren;
  "/workspaces/$slug/settings": typeof AuthenticatedWorkspacesSlugSettingsRoute;
  "/workspaces/$slug/subscription": typeof AuthenticatedWorkspacesSlugSubscriptionRoute;
  "/superuser/skills/": typeof AuthenticatedSuperuserSkillsIndexRoute;
  "/workspaces/$slug/": typeof AuthenticatedWorkspacesSlugIndexRoute;
  "/workspaces/$slug/create/profile": typeof AuthenticatedWorkspacesSlugCreateProfileRoute;
  "/workspaces/$slug/projects/$projectSlug": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRouteWithChildren;
  "/workspaces/$slug/projects/create": typeof AuthenticatedWorkspacesSlugProjectsCreateRoute;
  "/workspaces/$slug/projects/": typeof AuthenticatedWorkspacesSlugProjectsIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/agent-keys": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAgentKeysRoute;
  "/workspaces/$slug/projects/$projectSlug/change-requests": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugChangeRequestsRoute;
  "/workspaces/$slug/projects/$projectSlug/cr": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCrRouteWithChildren;
  "/workspaces/$slug/projects/$projectSlug/create": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRouteWithChildren;
  "/workspaces/$slug/projects/$projectSlug/integrations": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugIntegrationsRoute;
  "/workspaces/$slug/projects/$projectSlug/members": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugMembersRoute;
  "/workspaces/$slug/projects/$projectSlug/project-context": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugProjectContextRoute;
  "/workspaces/$slug/projects/$projectSlug/settings": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSettingsRoute;
  "/workspaces/$slug/projects/$projectSlug/suggestions": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRouteWithChildren;
  "/workspaces/$slug/projects/$projectSlug/tasks": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugTasksRoute;
  "/workspaces/$slug/projects/$projectSlug/welcome": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugWelcomeRoute;
  "/workspaces/$slug/projects/$projectSlug/": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/ai-team/$personaId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamPersonaIdRoute;
  "/workspaces/$slug/projects/$projectSlug/ai-team/new": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamNewRoute;
  "/workspaces/$slug/projects/$projectSlug/chats/$chatId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugChatsChatIdRoute;
  "/workspaces/$slug/projects/$projectSlug/cr/$crId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCrCrIdRoute;
  "/workspaces/$slug/projects/$projectSlug/create/docs": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCreateDocsRoute;
  "/workspaces/$slug/projects/$projectSlug/create/invite": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCreateInviteRoute;
  "/workspaces/$slug/projects/$projectSlug/docs/$docId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugDocsDocIdRoute;
  "/workspaces/$slug/projects/$projectSlug/skills/$skillId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsSkillIdRoute;
  "/workspaces/$slug/projects/$projectSlug/skills/import": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsImportRoute;
  "/workspaces/$slug/projects/$projectSlug/skills/new": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsNewRoute;
  "/workspaces/$slug/projects/$projectSlug/suggestions/$suggestionId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsSuggestionIdRoute;
  "/workspaces/$slug/projects/$projectSlug/ai-team/": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/chats/": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugChatsIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/docs/": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugDocsIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/messages/": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugMessagesIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/skills/": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/suggestions/": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/tools/": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugToolsIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/tools/$surface/$toolId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugToolsSurfaceToolIdRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/privacy": typeof PrivacyRoute;
  "/terms": typeof TermsRoute;
  "/superuser": typeof AuthenticatedSuperuserRouteWithChildren;
  "/support": typeof AuthenticatedSupportRoute;
  "/invite/$code": typeof InviteCodeRoute;
  "/login/check-email": typeof LoginCheckEmailRoute;
  "/signup/check-email": typeof SignupCheckEmailRoute;
  "/login": typeof LoginIndexRoute;
  "/signup": typeof SignupIndexRoute;
  "/account/api-keys": typeof AuthenticatedAccountApiKeysRoute;
  "/account/integrations": typeof AuthenticatedAccountIntegrationsRouteWithChildren;
  "/connect/$service": typeof AuthenticatedConnectServiceRoute;
  "/docs/$docId": typeof AuthenticatedDocsDocIdRoute;
  "/superuser/ai-settings": typeof AuthenticatedSuperuserAiSettingsRoute;
  "/superuser/integrations": typeof AuthenticatedSuperuserIntegrationsRoute;
  "/superuser/invites": typeof AuthenticatedSuperuserInvitesRoute;
  "/superuser/models": typeof AuthenticatedSuperuserModelsRoute;
  "/superuser/workspaces": typeof AuthenticatedSuperuserWorkspacesRoute;
  "/workspaces/create": typeof AuthenticatedWorkspacesCreateRoute;
  "/account": typeof AuthenticatedAccountIndexRoute;
  "/workspaces": typeof AuthenticatedWorkspacesIndexRoute;
  "/account/integrations/callback": typeof AuthenticatedAccountIntegrationsCallbackRoute;
  "/superuser/skills/$skillId": typeof AuthenticatedSuperuserSkillsSkillIdRoute;
  "/superuser/skills/import": typeof AuthenticatedSuperuserSkillsImportRoute;
  "/superuser/skills/new": typeof AuthenticatedSuperuserSkillsNewRoute;
  "/workspaces/$slug/agent-keys": typeof AuthenticatedWorkspacesSlugAgentKeysRoute;
  "/workspaces/$slug/ai-usage": typeof AuthenticatedWorkspacesSlugAiUsageRoute;
  "/workspaces/$slug/integrations": typeof AuthenticatedWorkspacesSlugIntegrationsRoute;
  "/workspaces/$slug/members": typeof AuthenticatedWorkspacesSlugMembersRoute;
  "/workspaces/$slug/settings": typeof AuthenticatedWorkspacesSlugSettingsRoute;
  "/workspaces/$slug/subscription": typeof AuthenticatedWorkspacesSlugSubscriptionRoute;
  "/superuser/skills": typeof AuthenticatedSuperuserSkillsIndexRoute;
  "/workspaces/$slug": typeof AuthenticatedWorkspacesSlugIndexRoute;
  "/workspaces/$slug/create/profile": typeof AuthenticatedWorkspacesSlugCreateProfileRoute;
  "/workspaces/$slug/projects/create": typeof AuthenticatedWorkspacesSlugProjectsCreateRoute;
  "/workspaces/$slug/projects": typeof AuthenticatedWorkspacesSlugProjectsIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/agent-keys": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAgentKeysRoute;
  "/workspaces/$slug/projects/$projectSlug/change-requests": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugChangeRequestsRoute;
  "/workspaces/$slug/projects/$projectSlug/cr": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCrRouteWithChildren;
  "/workspaces/$slug/projects/$projectSlug/create": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRouteWithChildren;
  "/workspaces/$slug/projects/$projectSlug/integrations": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugIntegrationsRoute;
  "/workspaces/$slug/projects/$projectSlug/members": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugMembersRoute;
  "/workspaces/$slug/projects/$projectSlug/project-context": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugProjectContextRoute;
  "/workspaces/$slug/projects/$projectSlug/settings": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSettingsRoute;
  "/workspaces/$slug/projects/$projectSlug/tasks": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugTasksRoute;
  "/workspaces/$slug/projects/$projectSlug/welcome": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugWelcomeRoute;
  "/workspaces/$slug/projects/$projectSlug": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/ai-team/$personaId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamPersonaIdRoute;
  "/workspaces/$slug/projects/$projectSlug/ai-team/new": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamNewRoute;
  "/workspaces/$slug/projects/$projectSlug/chats/$chatId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugChatsChatIdRoute;
  "/workspaces/$slug/projects/$projectSlug/cr/$crId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCrCrIdRoute;
  "/workspaces/$slug/projects/$projectSlug/create/docs": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCreateDocsRoute;
  "/workspaces/$slug/projects/$projectSlug/create/invite": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCreateInviteRoute;
  "/workspaces/$slug/projects/$projectSlug/docs/$docId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugDocsDocIdRoute;
  "/workspaces/$slug/projects/$projectSlug/skills/$skillId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsSkillIdRoute;
  "/workspaces/$slug/projects/$projectSlug/skills/import": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsImportRoute;
  "/workspaces/$slug/projects/$projectSlug/skills/new": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsNewRoute;
  "/workspaces/$slug/projects/$projectSlug/suggestions/$suggestionId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsSuggestionIdRoute;
  "/workspaces/$slug/projects/$projectSlug/ai-team": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/chats": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugChatsIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/docs": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugDocsIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/messages": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugMessagesIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/skills": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/suggestions": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/tools": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugToolsIndexRoute;
  "/workspaces/$slug/projects/$projectSlug/tools/$surface/$toolId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugToolsSurfaceToolIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_authenticated": typeof AuthenticatedRouteWithChildren;
  "/login": typeof LoginRouteWithChildren;
  "/privacy": typeof PrivacyRoute;
  "/signup": typeof SignupRouteWithChildren;
  "/terms": typeof TermsRoute;
  "/_authenticated/account": typeof AuthenticatedAccountRouteWithChildren;
  "/_authenticated/superuser": typeof AuthenticatedSuperuserRouteWithChildren;
  "/_authenticated/support": typeof AuthenticatedSupportRoute;
  "/_authenticated/workspaces": typeof AuthenticatedWorkspacesRouteWithChildren;
  "/invite/$code": typeof InviteCodeRoute;
  "/login/check-email": typeof LoginCheckEmailRoute;
  "/signup/check-email": typeof SignupCheckEmailRoute;
  "/login/": typeof LoginIndexRoute;
  "/signup/": typeof SignupIndexRoute;
  "/_authenticated/account/api-keys": typeof AuthenticatedAccountApiKeysRoute;
  "/_authenticated/account/integrations": typeof AuthenticatedAccountIntegrationsRouteWithChildren;
  "/_authenticated/connect/$service": typeof AuthenticatedConnectServiceRoute;
  "/_authenticated/docs/$docId": typeof AuthenticatedDocsDocIdRoute;
  "/_authenticated/superuser/ai-settings": typeof AuthenticatedSuperuserAiSettingsRoute;
  "/_authenticated/superuser/integrations": typeof AuthenticatedSuperuserIntegrationsRoute;
  "/_authenticated/superuser/invites": typeof AuthenticatedSuperuserInvitesRoute;
  "/_authenticated/superuser/models": typeof AuthenticatedSuperuserModelsRoute;
  "/_authenticated/superuser/workspaces": typeof AuthenticatedSuperuserWorkspacesRoute;
  "/_authenticated/workspaces/$slug": typeof AuthenticatedWorkspacesSlugRouteWithChildren;
  "/_authenticated/workspaces/create": typeof AuthenticatedWorkspacesCreateRoute;
  "/_authenticated/account/": typeof AuthenticatedAccountIndexRoute;
  "/_authenticated/workspaces/": typeof AuthenticatedWorkspacesIndexRoute;
  "/_authenticated/account/integrations/callback": typeof AuthenticatedAccountIntegrationsCallbackRoute;
  "/_authenticated/superuser/skills/$skillId": typeof AuthenticatedSuperuserSkillsSkillIdRoute;
  "/_authenticated/superuser/skills/import": typeof AuthenticatedSuperuserSkillsImportRoute;
  "/_authenticated/superuser/skills/new": typeof AuthenticatedSuperuserSkillsNewRoute;
  "/_authenticated/workspaces/$slug/agent-keys": typeof AuthenticatedWorkspacesSlugAgentKeysRoute;
  "/_authenticated/workspaces/$slug/ai-usage": typeof AuthenticatedWorkspacesSlugAiUsageRoute;
  "/_authenticated/workspaces/$slug/integrations": typeof AuthenticatedWorkspacesSlugIntegrationsRoute;
  "/_authenticated/workspaces/$slug/members": typeof AuthenticatedWorkspacesSlugMembersRoute;
  "/_authenticated/workspaces/$slug/projects": typeof AuthenticatedWorkspacesSlugProjectsRouteWithChildren;
  "/_authenticated/workspaces/$slug/settings": typeof AuthenticatedWorkspacesSlugSettingsRoute;
  "/_authenticated/workspaces/$slug/subscription": typeof AuthenticatedWorkspacesSlugSubscriptionRoute;
  "/_authenticated/superuser/skills/": typeof AuthenticatedSuperuserSkillsIndexRoute;
  "/_authenticated/workspaces/$slug/": typeof AuthenticatedWorkspacesSlugIndexRoute;
  "/_authenticated/workspaces/$slug/create/profile": typeof AuthenticatedWorkspacesSlugCreateProfileRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRouteWithChildren;
  "/_authenticated/workspaces/$slug/projects/create": typeof AuthenticatedWorkspacesSlugProjectsCreateRoute;
  "/_authenticated/workspaces/$slug/projects/": typeof AuthenticatedWorkspacesSlugProjectsIndexRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/agent-keys": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAgentKeysRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/change-requests": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugChangeRequestsRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/cr": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCrRouteWithChildren;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/create": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRouteWithChildren;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/integrations": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugIntegrationsRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/members": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugMembersRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/project-context": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugProjectContextRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/settings": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSettingsRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRouteWithChildren;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/tasks": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugTasksRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/welcome": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugWelcomeRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugIndexRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/$personaId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamPersonaIdRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/new": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamNewRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/chats/$chatId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugChatsChatIdRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/cr/$crId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCrCrIdRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/create/docs": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCreateDocsRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/create/invite": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCreateInviteRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/docs/$docId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugDocsDocIdRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/$skillId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsSkillIdRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/import": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsImportRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/new": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsNewRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions/$suggestionId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsSuggestionIdRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamIndexRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/chats/": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugChatsIndexRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/docs/": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugDocsIndexRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/messages/": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugMessagesIndexRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsIndexRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions/": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsIndexRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/tools/": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugToolsIndexRoute;
  "/_authenticated/workspaces/$slug/projects/$projectSlug/tools/$surface/$toolId": typeof AuthenticatedWorkspacesSlugProjectsProjectSlugToolsSurfaceToolIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/login"
    | "/privacy"
    | "/signup"
    | "/terms"
    | "/account"
    | "/superuser"
    | "/support"
    | "/workspaces"
    | "/invite/$code"
    | "/login/check-email"
    | "/signup/check-email"
    | "/login/"
    | "/signup/"
    | "/account/api-keys"
    | "/account/integrations"
    | "/connect/$service"
    | "/docs/$docId"
    | "/superuser/ai-settings"
    | "/superuser/integrations"
    | "/superuser/invites"
    | "/superuser/models"
    | "/superuser/workspaces"
    | "/workspaces/$slug"
    | "/workspaces/create"
    | "/account/"
    | "/workspaces/"
    | "/account/integrations/callback"
    | "/superuser/skills/$skillId"
    | "/superuser/skills/import"
    | "/superuser/skills/new"
    | "/workspaces/$slug/agent-keys"
    | "/workspaces/$slug/ai-usage"
    | "/workspaces/$slug/integrations"
    | "/workspaces/$slug/members"
    | "/workspaces/$slug/projects"
    | "/workspaces/$slug/settings"
    | "/workspaces/$slug/subscription"
    | "/superuser/skills/"
    | "/workspaces/$slug/"
    | "/workspaces/$slug/create/profile"
    | "/workspaces/$slug/projects/$projectSlug"
    | "/workspaces/$slug/projects/create"
    | "/workspaces/$slug/projects/"
    | "/workspaces/$slug/projects/$projectSlug/agent-keys"
    | "/workspaces/$slug/projects/$projectSlug/change-requests"
    | "/workspaces/$slug/projects/$projectSlug/cr"
    | "/workspaces/$slug/projects/$projectSlug/create"
    | "/workspaces/$slug/projects/$projectSlug/integrations"
    | "/workspaces/$slug/projects/$projectSlug/members"
    | "/workspaces/$slug/projects/$projectSlug/project-context"
    | "/workspaces/$slug/projects/$projectSlug/settings"
    | "/workspaces/$slug/projects/$projectSlug/suggestions"
    | "/workspaces/$slug/projects/$projectSlug/tasks"
    | "/workspaces/$slug/projects/$projectSlug/welcome"
    | "/workspaces/$slug/projects/$projectSlug/"
    | "/workspaces/$slug/projects/$projectSlug/ai-team/$personaId"
    | "/workspaces/$slug/projects/$projectSlug/ai-team/new"
    | "/workspaces/$slug/projects/$projectSlug/chats/$chatId"
    | "/workspaces/$slug/projects/$projectSlug/cr/$crId"
    | "/workspaces/$slug/projects/$projectSlug/create/docs"
    | "/workspaces/$slug/projects/$projectSlug/create/invite"
    | "/workspaces/$slug/projects/$projectSlug/docs/$docId"
    | "/workspaces/$slug/projects/$projectSlug/skills/$skillId"
    | "/workspaces/$slug/projects/$projectSlug/skills/import"
    | "/workspaces/$slug/projects/$projectSlug/skills/new"
    | "/workspaces/$slug/projects/$projectSlug/suggestions/$suggestionId"
    | "/workspaces/$slug/projects/$projectSlug/ai-team/"
    | "/workspaces/$slug/projects/$projectSlug/chats/"
    | "/workspaces/$slug/projects/$projectSlug/docs/"
    | "/workspaces/$slug/projects/$projectSlug/messages/"
    | "/workspaces/$slug/projects/$projectSlug/skills/"
    | "/workspaces/$slug/projects/$projectSlug/suggestions/"
    | "/workspaces/$slug/projects/$projectSlug/tools/"
    | "/workspaces/$slug/projects/$projectSlug/tools/$surface/$toolId";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/privacy"
    | "/terms"
    | "/superuser"
    | "/support"
    | "/invite/$code"
    | "/login/check-email"
    | "/signup/check-email"
    | "/login"
    | "/signup"
    | "/account/api-keys"
    | "/account/integrations"
    | "/connect/$service"
    | "/docs/$docId"
    | "/superuser/ai-settings"
    | "/superuser/integrations"
    | "/superuser/invites"
    | "/superuser/models"
    | "/superuser/workspaces"
    | "/workspaces/create"
    | "/account"
    | "/workspaces"
    | "/account/integrations/callback"
    | "/superuser/skills/$skillId"
    | "/superuser/skills/import"
    | "/superuser/skills/new"
    | "/workspaces/$slug/agent-keys"
    | "/workspaces/$slug/ai-usage"
    | "/workspaces/$slug/integrations"
    | "/workspaces/$slug/members"
    | "/workspaces/$slug/settings"
    | "/workspaces/$slug/subscription"
    | "/superuser/skills"
    | "/workspaces/$slug"
    | "/workspaces/$slug/create/profile"
    | "/workspaces/$slug/projects/create"
    | "/workspaces/$slug/projects"
    | "/workspaces/$slug/projects/$projectSlug/agent-keys"
    | "/workspaces/$slug/projects/$projectSlug/change-requests"
    | "/workspaces/$slug/projects/$projectSlug/cr"
    | "/workspaces/$slug/projects/$projectSlug/create"
    | "/workspaces/$slug/projects/$projectSlug/integrations"
    | "/workspaces/$slug/projects/$projectSlug/members"
    | "/workspaces/$slug/projects/$projectSlug/project-context"
    | "/workspaces/$slug/projects/$projectSlug/settings"
    | "/workspaces/$slug/projects/$projectSlug/tasks"
    | "/workspaces/$slug/projects/$projectSlug/welcome"
    | "/workspaces/$slug/projects/$projectSlug"
    | "/workspaces/$slug/projects/$projectSlug/ai-team/$personaId"
    | "/workspaces/$slug/projects/$projectSlug/ai-team/new"
    | "/workspaces/$slug/projects/$projectSlug/chats/$chatId"
    | "/workspaces/$slug/projects/$projectSlug/cr/$crId"
    | "/workspaces/$slug/projects/$projectSlug/create/docs"
    | "/workspaces/$slug/projects/$projectSlug/create/invite"
    | "/workspaces/$slug/projects/$projectSlug/docs/$docId"
    | "/workspaces/$slug/projects/$projectSlug/skills/$skillId"
    | "/workspaces/$slug/projects/$projectSlug/skills/import"
    | "/workspaces/$slug/projects/$projectSlug/skills/new"
    | "/workspaces/$slug/projects/$projectSlug/suggestions/$suggestionId"
    | "/workspaces/$slug/projects/$projectSlug/ai-team"
    | "/workspaces/$slug/projects/$projectSlug/chats"
    | "/workspaces/$slug/projects/$projectSlug/docs"
    | "/workspaces/$slug/projects/$projectSlug/messages"
    | "/workspaces/$slug/projects/$projectSlug/skills"
    | "/workspaces/$slug/projects/$projectSlug/suggestions"
    | "/workspaces/$slug/projects/$projectSlug/tools"
    | "/workspaces/$slug/projects/$projectSlug/tools/$surface/$toolId";
  id:
    | "__root__"
    | "/"
    | "/_authenticated"
    | "/login"
    | "/privacy"
    | "/signup"
    | "/terms"
    | "/_authenticated/account"
    | "/_authenticated/superuser"
    | "/_authenticated/support"
    | "/_authenticated/workspaces"
    | "/invite/$code"
    | "/login/check-email"
    | "/signup/check-email"
    | "/login/"
    | "/signup/"
    | "/_authenticated/account/api-keys"
    | "/_authenticated/account/integrations"
    | "/_authenticated/connect/$service"
    | "/_authenticated/docs/$docId"
    | "/_authenticated/superuser/ai-settings"
    | "/_authenticated/superuser/integrations"
    | "/_authenticated/superuser/invites"
    | "/_authenticated/superuser/models"
    | "/_authenticated/superuser/workspaces"
    | "/_authenticated/workspaces/$slug"
    | "/_authenticated/workspaces/create"
    | "/_authenticated/account/"
    | "/_authenticated/workspaces/"
    | "/_authenticated/account/integrations/callback"
    | "/_authenticated/superuser/skills/$skillId"
    | "/_authenticated/superuser/skills/import"
    | "/_authenticated/superuser/skills/new"
    | "/_authenticated/workspaces/$slug/agent-keys"
    | "/_authenticated/workspaces/$slug/ai-usage"
    | "/_authenticated/workspaces/$slug/integrations"
    | "/_authenticated/workspaces/$slug/members"
    | "/_authenticated/workspaces/$slug/projects"
    | "/_authenticated/workspaces/$slug/settings"
    | "/_authenticated/workspaces/$slug/subscription"
    | "/_authenticated/superuser/skills/"
    | "/_authenticated/workspaces/$slug/"
    | "/_authenticated/workspaces/$slug/create/profile"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug"
    | "/_authenticated/workspaces/$slug/projects/create"
    | "/_authenticated/workspaces/$slug/projects/"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/agent-keys"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/change-requests"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/cr"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/create"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/integrations"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/members"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/project-context"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/settings"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/tasks"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/welcome"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/$personaId"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/new"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/chats/$chatId"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/cr/$crId"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/create/docs"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/create/invite"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/docs/$docId"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/$skillId"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/import"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/new"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions/$suggestionId"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/chats/"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/docs/"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/messages/"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions/"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/tools/"
    | "/_authenticated/workspaces/$slug/projects/$projectSlug/tools/$surface/$toolId";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  LoginRoute: typeof LoginRouteWithChildren;
  PrivacyRoute: typeof PrivacyRoute;
  SignupRoute: typeof SignupRouteWithChildren;
  TermsRoute: typeof TermsRoute;
  InviteCodeRoute: typeof InviteCodeRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/terms": {
      id: "/terms";
      path: "/terms";
      fullPath: "/terms";
      preLoaderRoute: typeof TermsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/signup": {
      id: "/signup";
      path: "/signup";
      fullPath: "/signup";
      preLoaderRoute: typeof SignupRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/privacy": {
      id: "/privacy";
      path: "/privacy";
      fullPath: "/privacy";
      preLoaderRoute: typeof PrivacyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated": {
      id: "/_authenticated";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/signup/": {
      id: "/signup/";
      path: "/";
      fullPath: "/signup/";
      preLoaderRoute: typeof SignupIndexRouteImport;
      parentRoute: typeof SignupRoute;
    };
    "/login/": {
      id: "/login/";
      path: "/";
      fullPath: "/login/";
      preLoaderRoute: typeof LoginIndexRouteImport;
      parentRoute: typeof LoginRoute;
    };
    "/signup/check-email": {
      id: "/signup/check-email";
      path: "/check-email";
      fullPath: "/signup/check-email";
      preLoaderRoute: typeof SignupCheckEmailRouteImport;
      parentRoute: typeof SignupRoute;
    };
    "/login/check-email": {
      id: "/login/check-email";
      path: "/check-email";
      fullPath: "/login/check-email";
      preLoaderRoute: typeof LoginCheckEmailRouteImport;
      parentRoute: typeof LoginRoute;
    };
    "/invite/$code": {
      id: "/invite/$code";
      path: "/invite/$code";
      fullPath: "/invite/$code";
      preLoaderRoute: typeof InviteCodeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/workspaces": {
      id: "/_authenticated/workspaces";
      path: "/workspaces";
      fullPath: "/workspaces";
      preLoaderRoute: typeof AuthenticatedWorkspacesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/support": {
      id: "/_authenticated/support";
      path: "/support";
      fullPath: "/support";
      preLoaderRoute: typeof AuthenticatedSupportRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/superuser": {
      id: "/_authenticated/superuser";
      path: "/superuser";
      fullPath: "/superuser";
      preLoaderRoute: typeof AuthenticatedSuperuserRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/account": {
      id: "/_authenticated/account";
      path: "/account";
      fullPath: "/account";
      preLoaderRoute: typeof AuthenticatedAccountRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/workspaces/": {
      id: "/_authenticated/workspaces/";
      path: "/";
      fullPath: "/workspaces/";
      preLoaderRoute: typeof AuthenticatedWorkspacesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesRoute;
    };
    "/_authenticated/account/": {
      id: "/_authenticated/account/";
      path: "/";
      fullPath: "/account/";
      preLoaderRoute: typeof AuthenticatedAccountIndexRouteImport;
      parentRoute: typeof AuthenticatedAccountRoute;
    };
    "/_authenticated/workspaces/create": {
      id: "/_authenticated/workspaces/create";
      path: "/create";
      fullPath: "/workspaces/create";
      preLoaderRoute: typeof AuthenticatedWorkspacesCreateRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesRoute;
    };
    "/_authenticated/workspaces/$slug": {
      id: "/_authenticated/workspaces/$slug";
      path: "/$slug";
      fullPath: "/workspaces/$slug";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesRoute;
    };
    "/_authenticated/superuser/workspaces": {
      id: "/_authenticated/superuser/workspaces";
      path: "/workspaces";
      fullPath: "/superuser/workspaces";
      preLoaderRoute: typeof AuthenticatedSuperuserWorkspacesRouteImport;
      parentRoute: typeof AuthenticatedSuperuserRoute;
    };
    "/_authenticated/superuser/models": {
      id: "/_authenticated/superuser/models";
      path: "/models";
      fullPath: "/superuser/models";
      preLoaderRoute: typeof AuthenticatedSuperuserModelsRouteImport;
      parentRoute: typeof AuthenticatedSuperuserRoute;
    };
    "/_authenticated/superuser/invites": {
      id: "/_authenticated/superuser/invites";
      path: "/invites";
      fullPath: "/superuser/invites";
      preLoaderRoute: typeof AuthenticatedSuperuserInvitesRouteImport;
      parentRoute: typeof AuthenticatedSuperuserRoute;
    };
    "/_authenticated/superuser/integrations": {
      id: "/_authenticated/superuser/integrations";
      path: "/integrations";
      fullPath: "/superuser/integrations";
      preLoaderRoute: typeof AuthenticatedSuperuserIntegrationsRouteImport;
      parentRoute: typeof AuthenticatedSuperuserRoute;
    };
    "/_authenticated/superuser/ai-settings": {
      id: "/_authenticated/superuser/ai-settings";
      path: "/ai-settings";
      fullPath: "/superuser/ai-settings";
      preLoaderRoute: typeof AuthenticatedSuperuserAiSettingsRouteImport;
      parentRoute: typeof AuthenticatedSuperuserRoute;
    };
    "/_authenticated/docs/$docId": {
      id: "/_authenticated/docs/$docId";
      path: "/docs/$docId";
      fullPath: "/docs/$docId";
      preLoaderRoute: typeof AuthenticatedDocsDocIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/connect/$service": {
      id: "/_authenticated/connect/$service";
      path: "/connect/$service";
      fullPath: "/connect/$service";
      preLoaderRoute: typeof AuthenticatedConnectServiceRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/account/integrations": {
      id: "/_authenticated/account/integrations";
      path: "/integrations";
      fullPath: "/account/integrations";
      preLoaderRoute: typeof AuthenticatedAccountIntegrationsRouteImport;
      parentRoute: typeof AuthenticatedAccountRoute;
    };
    "/_authenticated/account/api-keys": {
      id: "/_authenticated/account/api-keys";
      path: "/api-keys";
      fullPath: "/account/api-keys";
      preLoaderRoute: typeof AuthenticatedAccountApiKeysRouteImport;
      parentRoute: typeof AuthenticatedAccountRoute;
    };
    "/_authenticated/workspaces/$slug/": {
      id: "/_authenticated/workspaces/$slug/";
      path: "/";
      fullPath: "/workspaces/$slug/";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugRoute;
    };
    "/_authenticated/superuser/skills/": {
      id: "/_authenticated/superuser/skills/";
      path: "/skills";
      fullPath: "/superuser/skills/";
      preLoaderRoute: typeof AuthenticatedSuperuserSkillsIndexRouteImport;
      parentRoute: typeof AuthenticatedSuperuserRoute;
    };
    "/_authenticated/workspaces/$slug/subscription": {
      id: "/_authenticated/workspaces/$slug/subscription";
      path: "/subscription";
      fullPath: "/workspaces/$slug/subscription";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugSubscriptionRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugRoute;
    };
    "/_authenticated/workspaces/$slug/settings": {
      id: "/_authenticated/workspaces/$slug/settings";
      path: "/settings";
      fullPath: "/workspaces/$slug/settings";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects": {
      id: "/_authenticated/workspaces/$slug/projects";
      path: "/projects";
      fullPath: "/workspaces/$slug/projects";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugRoute;
    };
    "/_authenticated/workspaces/$slug/members": {
      id: "/_authenticated/workspaces/$slug/members";
      path: "/members";
      fullPath: "/workspaces/$slug/members";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugMembersRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugRoute;
    };
    "/_authenticated/workspaces/$slug/integrations": {
      id: "/_authenticated/workspaces/$slug/integrations";
      path: "/integrations";
      fullPath: "/workspaces/$slug/integrations";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugIntegrationsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugRoute;
    };
    "/_authenticated/workspaces/$slug/ai-usage": {
      id: "/_authenticated/workspaces/$slug/ai-usage";
      path: "/ai-usage";
      fullPath: "/workspaces/$slug/ai-usage";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugAiUsageRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugRoute;
    };
    "/_authenticated/workspaces/$slug/agent-keys": {
      id: "/_authenticated/workspaces/$slug/agent-keys";
      path: "/agent-keys";
      fullPath: "/workspaces/$slug/agent-keys";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugAgentKeysRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugRoute;
    };
    "/_authenticated/superuser/skills/new": {
      id: "/_authenticated/superuser/skills/new";
      path: "/skills/new";
      fullPath: "/superuser/skills/new";
      preLoaderRoute: typeof AuthenticatedSuperuserSkillsNewRouteImport;
      parentRoute: typeof AuthenticatedSuperuserRoute;
    };
    "/_authenticated/superuser/skills/import": {
      id: "/_authenticated/superuser/skills/import";
      path: "/skills/import";
      fullPath: "/superuser/skills/import";
      preLoaderRoute: typeof AuthenticatedSuperuserSkillsImportRouteImport;
      parentRoute: typeof AuthenticatedSuperuserRoute;
    };
    "/_authenticated/superuser/skills/$skillId": {
      id: "/_authenticated/superuser/skills/$skillId";
      path: "/skills/$skillId";
      fullPath: "/superuser/skills/$skillId";
      preLoaderRoute: typeof AuthenticatedSuperuserSkillsSkillIdRouteImport;
      parentRoute: typeof AuthenticatedSuperuserRoute;
    };
    "/_authenticated/account/integrations/callback": {
      id: "/_authenticated/account/integrations/callback";
      path: "/callback";
      fullPath: "/account/integrations/callback";
      preLoaderRoute: typeof AuthenticatedAccountIntegrationsCallbackRouteImport;
      parentRoute: typeof AuthenticatedAccountIntegrationsRoute;
    };
    "/_authenticated/workspaces/$slug/projects/": {
      id: "/_authenticated/workspaces/$slug/projects/";
      path: "/";
      fullPath: "/workspaces/$slug/projects/";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsRoute;
    };
    "/_authenticated/workspaces/$slug/projects/create": {
      id: "/_authenticated/workspaces/$slug/projects/create";
      path: "/create";
      fullPath: "/workspaces/$slug/projects/create";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsCreateRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug";
      path: "/$projectSlug";
      fullPath: "/workspaces/$slug/projects/$projectSlug";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsRoute;
    };
    "/_authenticated/workspaces/$slug/create/profile": {
      id: "/_authenticated/workspaces/$slug/create/profile";
      path: "/create/profile";
      fullPath: "/workspaces/$slug/create/profile";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugCreateProfileRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/";
      path: "/";
      fullPath: "/workspaces/$slug/projects/$projectSlug/";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/welcome": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/welcome";
      path: "/welcome";
      fullPath: "/workspaces/$slug/projects/$projectSlug/welcome";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugWelcomeRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/tasks": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/tasks";
      path: "/tasks";
      fullPath: "/workspaces/$slug/projects/$projectSlug/tasks";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugTasksRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions";
      path: "/suggestions";
      fullPath: "/workspaces/$slug/projects/$projectSlug/suggestions";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/settings": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/settings";
      path: "/settings";
      fullPath: "/workspaces/$slug/projects/$projectSlug/settings";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSettingsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/project-context": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/project-context";
      path: "/project-context";
      fullPath: "/workspaces/$slug/projects/$projectSlug/project-context";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugProjectContextRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/members": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/members";
      path: "/members";
      fullPath: "/workspaces/$slug/projects/$projectSlug/members";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugMembersRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/integrations": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/integrations";
      path: "/integrations";
      fullPath: "/workspaces/$slug/projects/$projectSlug/integrations";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugIntegrationsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/create": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/create";
      path: "/create";
      fullPath: "/workspaces/$slug/projects/$projectSlug/create";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/cr": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/cr";
      path: "/cr";
      fullPath: "/workspaces/$slug/projects/$projectSlug/cr";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCrRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/change-requests": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/change-requests";
      path: "/change-requests";
      fullPath: "/workspaces/$slug/projects/$projectSlug/change-requests";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugChangeRequestsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/agent-keys": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/agent-keys";
      path: "/agent-keys";
      fullPath: "/workspaces/$slug/projects/$projectSlug/agent-keys";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAgentKeysRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/tools/": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/tools/";
      path: "/tools";
      fullPath: "/workspaces/$slug/projects/$projectSlug/tools/";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugToolsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions/": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions/";
      path: "/";
      fullPath: "/workspaces/$slug/projects/$projectSlug/suggestions/";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/";
      path: "/skills";
      fullPath: "/workspaces/$slug/projects/$projectSlug/skills/";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/messages/": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/messages/";
      path: "/messages";
      fullPath: "/workspaces/$slug/projects/$projectSlug/messages/";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugMessagesIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/docs/": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/docs/";
      path: "/docs";
      fullPath: "/workspaces/$slug/projects/$projectSlug/docs/";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugDocsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/chats/": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/chats/";
      path: "/chats";
      fullPath: "/workspaces/$slug/projects/$projectSlug/chats/";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugChatsIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/";
      path: "/ai-team";
      fullPath: "/workspaces/$slug/projects/$projectSlug/ai-team/";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamIndexRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions/$suggestionId": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/suggestions/$suggestionId";
      path: "/$suggestionId";
      fullPath: "/workspaces/$slug/projects/$projectSlug/suggestions/$suggestionId";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsSuggestionIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/new": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/new";
      path: "/skills/new";
      fullPath: "/workspaces/$slug/projects/$projectSlug/skills/new";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/import": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/import";
      path: "/skills/import";
      fullPath: "/workspaces/$slug/projects/$projectSlug/skills/import";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsImportRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/$skillId": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/skills/$skillId";
      path: "/skills/$skillId";
      fullPath: "/workspaces/$slug/projects/$projectSlug/skills/$skillId";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsSkillIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/docs/$docId": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/docs/$docId";
      path: "/docs/$docId";
      fullPath: "/workspaces/$slug/projects/$projectSlug/docs/$docId";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugDocsDocIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/create/invite": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/create/invite";
      path: "/invite";
      fullPath: "/workspaces/$slug/projects/$projectSlug/create/invite";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCreateInviteRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/create/docs": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/create/docs";
      path: "/docs";
      fullPath: "/workspaces/$slug/projects/$projectSlug/create/docs";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCreateDocsRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/cr/$crId": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/cr/$crId";
      path: "/$crId";
      fullPath: "/workspaces/$slug/projects/$projectSlug/cr/$crId";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCrCrIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCrRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/chats/$chatId": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/chats/$chatId";
      path: "/chats/$chatId";
      fullPath: "/workspaces/$slug/projects/$projectSlug/chats/$chatId";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugChatsChatIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/new": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/new";
      path: "/ai-team/new";
      fullPath: "/workspaces/$slug/projects/$projectSlug/ai-team/new";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamNewRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/$personaId": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/ai-team/$personaId";
      path: "/ai-team/$personaId";
      fullPath: "/workspaces/$slug/projects/$projectSlug/ai-team/$personaId";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamPersonaIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
    "/_authenticated/workspaces/$slug/projects/$projectSlug/tools/$surface/$toolId": {
      id: "/_authenticated/workspaces/$slug/projects/$projectSlug/tools/$surface/$toolId";
      path: "/tools/$surface/$toolId";
      fullPath: "/workspaces/$slug/projects/$projectSlug/tools/$surface/$toolId";
      preLoaderRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugToolsSurfaceToolIdRouteImport;
      parentRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRoute;
    };
  }
}

interface AuthenticatedAccountIntegrationsRouteChildren {
  AuthenticatedAccountIntegrationsCallbackRoute: typeof AuthenticatedAccountIntegrationsCallbackRoute;
}

const AuthenticatedAccountIntegrationsRouteChildren: AuthenticatedAccountIntegrationsRouteChildren =
  {
    AuthenticatedAccountIntegrationsCallbackRoute:
      AuthenticatedAccountIntegrationsCallbackRoute,
  };

const AuthenticatedAccountIntegrationsRouteWithChildren =
  AuthenticatedAccountIntegrationsRoute._addFileChildren(
    AuthenticatedAccountIntegrationsRouteChildren,
  );

interface AuthenticatedAccountRouteChildren {
  AuthenticatedAccountApiKeysRoute: typeof AuthenticatedAccountApiKeysRoute;
  AuthenticatedAccountIntegrationsRoute: typeof AuthenticatedAccountIntegrationsRouteWithChildren;
  AuthenticatedAccountIndexRoute: typeof AuthenticatedAccountIndexRoute;
}

const AuthenticatedAccountRouteChildren: AuthenticatedAccountRouteChildren = {
  AuthenticatedAccountApiKeysRoute: AuthenticatedAccountApiKeysRoute,
  AuthenticatedAccountIntegrationsRoute:
    AuthenticatedAccountIntegrationsRouteWithChildren,
  AuthenticatedAccountIndexRoute: AuthenticatedAccountIndexRoute,
};

const AuthenticatedAccountRouteWithChildren =
  AuthenticatedAccountRoute._addFileChildren(AuthenticatedAccountRouteChildren);

interface AuthenticatedSuperuserRouteChildren {
  AuthenticatedSuperuserAiSettingsRoute: typeof AuthenticatedSuperuserAiSettingsRoute;
  AuthenticatedSuperuserIntegrationsRoute: typeof AuthenticatedSuperuserIntegrationsRoute;
  AuthenticatedSuperuserInvitesRoute: typeof AuthenticatedSuperuserInvitesRoute;
  AuthenticatedSuperuserModelsRoute: typeof AuthenticatedSuperuserModelsRoute;
  AuthenticatedSuperuserWorkspacesRoute: typeof AuthenticatedSuperuserWorkspacesRoute;
  AuthenticatedSuperuserSkillsSkillIdRoute: typeof AuthenticatedSuperuserSkillsSkillIdRoute;
  AuthenticatedSuperuserSkillsImportRoute: typeof AuthenticatedSuperuserSkillsImportRoute;
  AuthenticatedSuperuserSkillsNewRoute: typeof AuthenticatedSuperuserSkillsNewRoute;
  AuthenticatedSuperuserSkillsIndexRoute: typeof AuthenticatedSuperuserSkillsIndexRoute;
}

const AuthenticatedSuperuserRouteChildren: AuthenticatedSuperuserRouteChildren =
  {
    AuthenticatedSuperuserAiSettingsRoute:
      AuthenticatedSuperuserAiSettingsRoute,
    AuthenticatedSuperuserIntegrationsRoute:
      AuthenticatedSuperuserIntegrationsRoute,
    AuthenticatedSuperuserInvitesRoute: AuthenticatedSuperuserInvitesRoute,
    AuthenticatedSuperuserModelsRoute: AuthenticatedSuperuserModelsRoute,
    AuthenticatedSuperuserWorkspacesRoute:
      AuthenticatedSuperuserWorkspacesRoute,
    AuthenticatedSuperuserSkillsSkillIdRoute:
      AuthenticatedSuperuserSkillsSkillIdRoute,
    AuthenticatedSuperuserSkillsImportRoute:
      AuthenticatedSuperuserSkillsImportRoute,
    AuthenticatedSuperuserSkillsNewRoute: AuthenticatedSuperuserSkillsNewRoute,
    AuthenticatedSuperuserSkillsIndexRoute:
      AuthenticatedSuperuserSkillsIndexRoute,
  };

const AuthenticatedSuperuserRouteWithChildren =
  AuthenticatedSuperuserRoute._addFileChildren(
    AuthenticatedSuperuserRouteChildren,
  );

interface AuthenticatedWorkspacesSlugProjectsProjectSlugCrRouteChildren {
  AuthenticatedWorkspacesSlugProjectsProjectSlugCrCrIdRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCrCrIdRoute;
}

const AuthenticatedWorkspacesSlugProjectsProjectSlugCrRouteChildren: AuthenticatedWorkspacesSlugProjectsProjectSlugCrRouteChildren =
  {
    AuthenticatedWorkspacesSlugProjectsProjectSlugCrCrIdRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugCrCrIdRoute,
  };

const AuthenticatedWorkspacesSlugProjectsProjectSlugCrRouteWithChildren =
  AuthenticatedWorkspacesSlugProjectsProjectSlugCrRoute._addFileChildren(
    AuthenticatedWorkspacesSlugProjectsProjectSlugCrRouteChildren,
  );

interface AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRouteChildren {
  AuthenticatedWorkspacesSlugProjectsProjectSlugCreateDocsRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCreateDocsRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugCreateInviteRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCreateInviteRoute;
}

const AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRouteChildren: AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRouteChildren =
  {
    AuthenticatedWorkspacesSlugProjectsProjectSlugCreateDocsRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugCreateDocsRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugCreateInviteRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugCreateInviteRoute,
  };

const AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRouteWithChildren =
  AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRoute._addFileChildren(
    AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRouteChildren,
  );

interface AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRouteChildren {
  AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsSuggestionIdRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsSuggestionIdRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsIndexRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsIndexRoute;
}

const AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRouteChildren: AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRouteChildren =
  {
    AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsSuggestionIdRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsSuggestionIdRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsIndexRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsIndexRoute,
  };

const AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRouteWithChildren =
  AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRoute._addFileChildren(
    AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRouteChildren,
  );

interface AuthenticatedWorkspacesSlugProjectsProjectSlugRouteChildren {
  AuthenticatedWorkspacesSlugProjectsProjectSlugAgentKeysRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAgentKeysRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugChangeRequestsRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugChangeRequestsRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugCrRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCrRouteWithChildren;
  AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRouteWithChildren;
  AuthenticatedWorkspacesSlugProjectsProjectSlugIntegrationsRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugIntegrationsRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugMembersRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugMembersRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugProjectContextRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugProjectContextRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugSettingsRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSettingsRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRouteWithChildren;
  AuthenticatedWorkspacesSlugProjectsProjectSlugTasksRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugTasksRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugWelcomeRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugWelcomeRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugIndexRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugIndexRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamPersonaIdRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamPersonaIdRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamNewRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamNewRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugChatsChatIdRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugChatsChatIdRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugDocsDocIdRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugDocsDocIdRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsSkillIdRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsSkillIdRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsImportRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsImportRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsNewRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsNewRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamIndexRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamIndexRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugChatsIndexRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugChatsIndexRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugDocsIndexRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugDocsIndexRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugMessagesIndexRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugMessagesIndexRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsIndexRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsIndexRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugToolsIndexRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugToolsIndexRoute;
  AuthenticatedWorkspacesSlugProjectsProjectSlugToolsSurfaceToolIdRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugToolsSurfaceToolIdRoute;
}

const AuthenticatedWorkspacesSlugProjectsProjectSlugRouteChildren: AuthenticatedWorkspacesSlugProjectsProjectSlugRouteChildren =
  {
    AuthenticatedWorkspacesSlugProjectsProjectSlugAgentKeysRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugAgentKeysRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugChangeRequestsRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugChangeRequestsRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugCrRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugCrRouteWithChildren,
    AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugCreateRouteWithChildren,
    AuthenticatedWorkspacesSlugProjectsProjectSlugIntegrationsRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugIntegrationsRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugMembersRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugMembersRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugProjectContextRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugProjectContextRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugSettingsRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugSettingsRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugSuggestionsRouteWithChildren,
    AuthenticatedWorkspacesSlugProjectsProjectSlugTasksRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugTasksRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugWelcomeRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugWelcomeRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugIndexRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugIndexRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamPersonaIdRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamPersonaIdRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamNewRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamNewRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugChatsChatIdRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugChatsChatIdRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugDocsDocIdRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugDocsDocIdRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsSkillIdRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsSkillIdRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsImportRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsImportRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsNewRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsNewRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamIndexRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugAiTeamIndexRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugChatsIndexRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugChatsIndexRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugDocsIndexRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugDocsIndexRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugMessagesIndexRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugMessagesIndexRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsIndexRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugSkillsIndexRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugToolsIndexRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugToolsIndexRoute,
    AuthenticatedWorkspacesSlugProjectsProjectSlugToolsSurfaceToolIdRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugToolsSurfaceToolIdRoute,
  };

const AuthenticatedWorkspacesSlugProjectsProjectSlugRouteWithChildren =
  AuthenticatedWorkspacesSlugProjectsProjectSlugRoute._addFileChildren(
    AuthenticatedWorkspacesSlugProjectsProjectSlugRouteChildren,
  );

interface AuthenticatedWorkspacesSlugProjectsRouteChildren {
  AuthenticatedWorkspacesSlugProjectsProjectSlugRoute: typeof AuthenticatedWorkspacesSlugProjectsProjectSlugRouteWithChildren;
  AuthenticatedWorkspacesSlugProjectsCreateRoute: typeof AuthenticatedWorkspacesSlugProjectsCreateRoute;
  AuthenticatedWorkspacesSlugProjectsIndexRoute: typeof AuthenticatedWorkspacesSlugProjectsIndexRoute;
}

const AuthenticatedWorkspacesSlugProjectsRouteChildren: AuthenticatedWorkspacesSlugProjectsRouteChildren =
  {
    AuthenticatedWorkspacesSlugProjectsProjectSlugRoute:
      AuthenticatedWorkspacesSlugProjectsProjectSlugRouteWithChildren,
    AuthenticatedWorkspacesSlugProjectsCreateRoute:
      AuthenticatedWorkspacesSlugProjectsCreateRoute,
    AuthenticatedWorkspacesSlugProjectsIndexRoute:
      AuthenticatedWorkspacesSlugProjectsIndexRoute,
  };

const AuthenticatedWorkspacesSlugProjectsRouteWithChildren =
  AuthenticatedWorkspacesSlugProjectsRoute._addFileChildren(
    AuthenticatedWorkspacesSlugProjectsRouteChildren,
  );

interface AuthenticatedWorkspacesSlugRouteChildren {
  AuthenticatedWorkspacesSlugAgentKeysRoute: typeof AuthenticatedWorkspacesSlugAgentKeysRoute;
  AuthenticatedWorkspacesSlugAiUsageRoute: typeof AuthenticatedWorkspacesSlugAiUsageRoute;
  AuthenticatedWorkspacesSlugIntegrationsRoute: typeof AuthenticatedWorkspacesSlugIntegrationsRoute;
  AuthenticatedWorkspacesSlugMembersRoute: typeof AuthenticatedWorkspacesSlugMembersRoute;
  AuthenticatedWorkspacesSlugProjectsRoute: typeof AuthenticatedWorkspacesSlugProjectsRouteWithChildren;
  AuthenticatedWorkspacesSlugSettingsRoute: typeof AuthenticatedWorkspacesSlugSettingsRoute;
  AuthenticatedWorkspacesSlugSubscriptionRoute: typeof AuthenticatedWorkspacesSlugSubscriptionRoute;
  AuthenticatedWorkspacesSlugIndexRoute: typeof AuthenticatedWorkspacesSlugIndexRoute;
  AuthenticatedWorkspacesSlugCreateProfileRoute: typeof AuthenticatedWorkspacesSlugCreateProfileRoute;
}

const AuthenticatedWorkspacesSlugRouteChildren: AuthenticatedWorkspacesSlugRouteChildren =
  {
    AuthenticatedWorkspacesSlugAgentKeysRoute:
      AuthenticatedWorkspacesSlugAgentKeysRoute,
    AuthenticatedWorkspacesSlugAiUsageRoute:
      AuthenticatedWorkspacesSlugAiUsageRoute,
    AuthenticatedWorkspacesSlugIntegrationsRoute:
      AuthenticatedWorkspacesSlugIntegrationsRoute,
    AuthenticatedWorkspacesSlugMembersRoute:
      AuthenticatedWorkspacesSlugMembersRoute,
    AuthenticatedWorkspacesSlugProjectsRoute:
      AuthenticatedWorkspacesSlugProjectsRouteWithChildren,
    AuthenticatedWorkspacesSlugSettingsRoute:
      AuthenticatedWorkspacesSlugSettingsRoute,
    AuthenticatedWorkspacesSlugSubscriptionRoute:
      AuthenticatedWorkspacesSlugSubscriptionRoute,
    AuthenticatedWorkspacesSlugIndexRoute:
      AuthenticatedWorkspacesSlugIndexRoute,
    AuthenticatedWorkspacesSlugCreateProfileRoute:
      AuthenticatedWorkspacesSlugCreateProfileRoute,
  };

const AuthenticatedWorkspacesSlugRouteWithChildren =
  AuthenticatedWorkspacesSlugRoute._addFileChildren(
    AuthenticatedWorkspacesSlugRouteChildren,
  );

interface AuthenticatedWorkspacesRouteChildren {
  AuthenticatedWorkspacesSlugRoute: typeof AuthenticatedWorkspacesSlugRouteWithChildren;
  AuthenticatedWorkspacesCreateRoute: typeof AuthenticatedWorkspacesCreateRoute;
  AuthenticatedWorkspacesIndexRoute: typeof AuthenticatedWorkspacesIndexRoute;
}

const AuthenticatedWorkspacesRouteChildren: AuthenticatedWorkspacesRouteChildren =
  {
    AuthenticatedWorkspacesSlugRoute:
      AuthenticatedWorkspacesSlugRouteWithChildren,
    AuthenticatedWorkspacesCreateRoute: AuthenticatedWorkspacesCreateRoute,
    AuthenticatedWorkspacesIndexRoute: AuthenticatedWorkspacesIndexRoute,
  };

const AuthenticatedWorkspacesRouteWithChildren =
  AuthenticatedWorkspacesRoute._addFileChildren(
    AuthenticatedWorkspacesRouteChildren,
  );

interface AuthenticatedRouteChildren {
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRouteWithChildren;
  AuthenticatedSuperuserRoute: typeof AuthenticatedSuperuserRouteWithChildren;
  AuthenticatedSupportRoute: typeof AuthenticatedSupportRoute;
  AuthenticatedWorkspacesRoute: typeof AuthenticatedWorkspacesRouteWithChildren;
  AuthenticatedConnectServiceRoute: typeof AuthenticatedConnectServiceRoute;
  AuthenticatedDocsDocIdRoute: typeof AuthenticatedDocsDocIdRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRouteWithChildren,
  AuthenticatedSuperuserRoute: AuthenticatedSuperuserRouteWithChildren,
  AuthenticatedSupportRoute: AuthenticatedSupportRoute,
  AuthenticatedWorkspacesRoute: AuthenticatedWorkspacesRouteWithChildren,
  AuthenticatedConnectServiceRoute: AuthenticatedConnectServiceRoute,
  AuthenticatedDocsDocIdRoute: AuthenticatedDocsDocIdRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

interface LoginRouteChildren {
  LoginCheckEmailRoute: typeof LoginCheckEmailRoute;
  LoginIndexRoute: typeof LoginIndexRoute;
}

const LoginRouteChildren: LoginRouteChildren = {
  LoginCheckEmailRoute: LoginCheckEmailRoute,
  LoginIndexRoute: LoginIndexRoute,
};

const LoginRouteWithChildren = LoginRoute._addFileChildren(LoginRouteChildren);

interface SignupRouteChildren {
  SignupCheckEmailRoute: typeof SignupCheckEmailRoute;
  SignupIndexRoute: typeof SignupIndexRoute;
}

const SignupRouteChildren: SignupRouteChildren = {
  SignupCheckEmailRoute: SignupCheckEmailRoute,
  SignupIndexRoute: SignupIndexRoute,
};

const SignupRouteWithChildren =
  SignupRoute._addFileChildren(SignupRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  SignupRoute: SignupRouteWithChildren,
  TermsRoute: TermsRoute,
  InviteCodeRoute: InviteCodeRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
